<template>
    <div style="padding: 20px;">
        An error occured.
        <router-link to="/">
            Back to homepage
        </router-link>
    </div>
</template>

<script>
export default {

};
</script>
